/** Backend-enforced size and count limits */
export const LIMITS = Object.freeze({
  /** Max bytes for jobDescription field */
  JOB_DESCRIPTION_MAX_BYTES: 300 * 1024,

  /** Max bytes for notes field */
  NOTES_MAX_BYTES: 50 * 1024,

  /** Max bytes for a single debrief entry (sum of all text fields) */
  DEBRIEF_ENTRY_MAX_BYTES: 20 * 1024,

  /** Max bytes for total blob item (jobDescription + notes + debrief combined) */
  BLOB_TOTAL_MAX_BYTES: 350 * 1024,

  /** Max character length for company name */
  COMPANY_MAX_LENGTH: 500,

  /** Max character length for role title */
  ROLE_MAX_LENGTH: 500,

  /** Max character length for dispositionNote free text */
  DISPOSITION_NOTE_MAX_LENGTH: 500,

  /** Max number of tags per application */
  TAGS_MAX_COUNT: 20,

  /** Max entries in statusHistory before oldest are trimmed */
  STATUS_HISTORY_MAX_ENTRIES: 200,

  /** Max items in a single batch-reorder or batch-status request */
  BATCH_MAX_ITEMS: 100,

  /** Default column order spacing for new cards */
  COLUMN_ORDER_SPACING: 100,

  /** Threshold below which batch-reorder is triggered */
  COLUMN_ORDER_MIN_SPACING: 1e-9,
});
